import { LocalDate, LocalDateTime, ZoneOffset } from 'js-joda';

import { BusinessHoursWeekdayMap } from 'types';
import { adjustForBusinessDay } from 'utils/timeUtils';
import { isEmpty, map, sortBy } from 'es-toolkit/compat';

export interface IServiceObject {
  endTime: LocalDateTime;
  serviceType: string;
  startTime: LocalDateTime;
}

/**
 * Get service details for all services on a date.
 * @param {LocalDate} serviceDate The service date to get service details for.
 * @param {any} services The services set up,
 * @returns {IServiceObject[]} A list of the start and end times for each service on the serviceDate.
 */
export default function getServiceDayDetails(
  serviceDate: LocalDate,
  services: BusinessHoursWeekdayMap
): IServiceObject[] {
  const weekdayName = serviceDate.dayOfWeek().name();

  if (isEmpty(services)) {
    return [];
  }

  const serviceObjects = map(services[weekdayName], (service) => {
    const startTime = adjustForBusinessDay(serviceDate.toString(), service.startTime);
    const endTime = adjustForBusinessDay(serviceDate.toString(), service.endTime);
    return {
      serviceType: service.serviceType,
      startTime,
      endTime,
    };
  });

  return sortBy(serviceObjects, (serviceObject) => {
    return serviceObject.startTime.toEpochSecond(ZoneOffset.UTC);
  });
}
